import { z } from "zod";
import { IntegrationBaseSchema, IntegrationKey } from "./base";

/**
 * Famous Integration Settings Schema
 */
export const FamousIntegrationSettingsSchema = z.object({
  productMapping: z
    .object({
      useCustomerProducts: z.boolean().prefault(true),
    })
    .prefault({}),
  salesOrders: z
    .object({
      removeZeroQuantityLineItemsOnApproval: z.boolean().prefault(true),
    })
    .prefault({}),
});

/**
 * Famous Integration Settings Type
 */
export type FamousIntegrationSettings = z.infer<
  typeof FamousIntegrationSettingsSchema
>;

/**
 * Famous integration variant (without base fields)
 */
export const FamousIntegrationSettingsSchemaWithoutBase = z.object({
  key: z.literal(IntegrationKey.Famous),
  settings: FamousIntegrationSettingsSchema,
});

/**
 * Full Famous integration schema (with base fields)
 */
export const FamousIntegrationSchema = IntegrationBaseSchema.merge(
  FamousIntegrationSettingsSchemaWithoutBase,
);

/**
 * Famous Integration Type
 */
export type FamousIntegration = z.infer<typeof FamousIntegrationSchema>;
